var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-bar",style:({ backgroundColor: _vm.levelColor })},[_c('p',{staticClass:"warning-bar-message"},[_vm._v(_vm._s(_vm.message))]),_c('button',{on:{"click":_vm.onDelete}},[_c('img',{staticClass:"warning-bar-delete",attrs:{"src":require("@imgs/monitor-center-waring-bar-delete.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }